module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_2_4.580a2f74.png";